<template>
  <div>
    <VersionControlPopup
      ref="version-control-popup"
      :current-file="file"
      :id="id"
      :folder-type="folderType"
      @refresh="emitRefresh"
    />
    <ul class="list-group">
      <li
        class="list-group-item"
        :style="{
          borderLeft: 'none',
          borderRight: 'none',
          paddingLeft: `${20 * depth + 20}px`,
        }"
        :key="file.name"
      >
        <div class="file-name d-flex align-items-center">
          <font-awesome-icon
            :color="getIconColor(file.name)"
            :icon="getFileIcon(file.name)"
            @click="useCustoms ? customDownload(file) : download(file)"
          ></font-awesome-icon>
          <div
            class="d-flex flex-column justify-content-center"
            @click="useCustoms ? customDownload(file) : download(file)"
            style="width: 100%"
          >
            <div class="d-flex align-items-center ml-2" style="height: 40px">
              <span>{{
                `${file.name}${
                  fileUpload && fileUpload.status === "selected" ? " (old)" : ""
                }`
              }}</span>
              <span
                v-if="
                  fileUpload &&
                  fileUpload.status &&
                  fileUpload.status !== 'selected'
                "
                class="ml-2"
              >
                <el-tooltip
                  v-if="fileUpload.status === 'failed'"
                  effect="dark"
                  placement="top"
                  :content="fileUpload.high_msg || 'Upload failed'"
                >
                  <font-awesome-icon
                    size="lg"
                    :color="getAlertIconColor(fileUpload.status)"
                    :icon="getAlertIcon(fileUpload.status)"
                  />
                </el-tooltip>
                <font-awesome-icon
                  v-else
                  size="lg"
                  :color="getAlertIconColor(fileUpload.status)"
                  :icon="getAlertIcon(fileUpload.status)"
                />
              </span>
              <span
                v-if="fileUpload && fileUpload.status === 'selected'"
                class="ml-2"
                style="line-height: 40px"
              >
                ---> {{ `${fileUpload.fileName} (new)` }}</span
              >
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-center"
            style="width: 200px"
          >
            <div
              v-if="file.errors"
              class="show-details-button"
              @click="() => showErrorDetails = !showErrorDetails"
            >
              {{ showErrorDetails ?  'Hide details': 'Show details'}}
              <div class="w-100 mt-1 align-items-center justify-content-center text-center">
                <font-awesome-icon
                  class="warning-icon"
                  icon="exclamation-triangle"
                />
                <span v-if="file.errors.length">
                  ( {{ file.errors.length }} )
                </span>
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-center justify-content-center"
            style="width: 100px"
          >
<!--            v-if="file.file_type != 'request_form'"-->
            <el-upload
              class="upload-file"
              :ref="`upload-${file.name}`"
              :show-file-list="false"
              :headers="{ Authorization: authToken }"
              :data="{
                filename: file.name,
                filetype: file.file_type,
                foldertype: folderType
              }"
              :on-change="(f, flist) => handleChange(f)"
              :on-success="(res) => handleSuccess(res)"
              :action="`${baseUrl}/study/${id}/upload`"
              :auto-upload="false"
            >
              <el-button
                :disabled="uploadDisabled"
                :class="{
                  'upload-button': true,
                  visible: !fileUpload || fileUpload.status !== 'selected',
                }"
                slot="trigger"
                size="small"
                type="primary"
              >
                Update
              </el-button>
              <el-button
                :class="{
                  'upload-button': true,
                  visible: fileUpload && fileUpload.status === 'selected',
                }"
                size="small"
                type="success"
                @click.stop="useCustoms ? customUpload() : submitUpload(file.name)"
                >Confirm</el-button
              >
              <el-button
                :class="{
                  'upload-button': true,
                  visible: fileUpload && fileUpload.status === 'selected',
                }"
                class="mt-1 ml-0"
                size="small"
                type="warning"
                @click.stop="useCustoms ? customCancelUpload() : cancelUpload(file.name)"
                >Cancel</el-button
              >
              <el-button
                  v-if="showVersionControlButton"
                :disabled="uploadDisabled"
                class="mt-1 ml-0"
                tslot="trigger"
                size="small"
                type="primary"
                @click="
                  () => {
                    $refs['version-control-popup'].showPopup();
                  }
                "
              >
                Version Control
              </el-button>
            </el-upload>
          </div>
        </div>
        <ErrorDetailsTable
          v-if="file.errors && showErrorDetails"
          class="mt-3"
          :errors="file.errors"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import studyActions from '../../store/modules/studies/actionTypes'
import VersionControlPopup from '../FileStructure/VersionControlPopup'
import ErrorDetailsTable from '@/components/FileStructure/ErrorDetailsTable'

export default {
  name: 'FileList',
  components: { VersionControlPopup, ErrorDetailsTable },
  props: {
    file: Object,
    depth: Number,
    folderType: String,
    showVersionControlButton: {
      type: Boolean,
      default: true
    },
    useCustoms: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      id: this.$route.params.id,
      authToken: window.localStorage.getItem('auth_token_default'),
      uploadInterval: null,
      fileUpload: null,
      uploadDisabled: false,
      showErrorDetails: false
    }
  },
  methods: {
    ...mapActions({
      getFileUploadJobStatus: studyActions.CHECK_STUDY_FILE_UPLOAD_STATUS
    }),
    download (f) {
      this.axios({
        url: '/study/' + this.id + '/study-files-path/' + f.name,
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', f.name)
        document.body.appendChild(link)
        link.click()
      })
    },
    getFileIcon (fileName) {
      const type = fileName.split('.').pop()
      switch (type) {
        case 'doc':
          return 'file-word'
        case 'docx':
          return 'file-word'
        case 'ppt':
          return 'file-powerpoint'
        case 'pptx':
          return 'file-powerpoint'
        case 'pdf':
          return 'file-pdf'
        case 'xlsx':
          return 'file-excel'
        case 'xls':
          return 'file-excel'
        default:
          return 'file-alt'
      }
    },
    getAlertIcon (status) {
      switch (status) {
        case 'queued':
          return 'pause-circle'
        case 'started':
          return 'circle-notch'
        case 'failed':
          return 'times-circle'
        case 'finished':
          return 'check-circle'
        default:
          return ''
      }
    },
    getAlertIconColor (status) {
      switch (status) {
        case 'queued':
          return '#DA7B11'
        case 'started':
          return '#2D5897'
        case 'failed':
          return '#CE462E'
        case 'finished':
          return '#187240'
        default:
          return '#444444'
      }
    },
    getIconColor (fileName) {
      const type = fileName.split('.').pop()
      switch (type) {
        case 'doc':
          return '#2D5897'
        case 'docx':
          return '#2D5897'
        case 'ppt':
          return '#CE462E'
        case 'pptx':
          return '#CE462E'
        case 'pdf':
          return '#FF0000'
        case 'xlsx':
          return '#187240'
        case 'xls':
          return '#187240'
        default:
          return '#444444'
      }
    },
    handleChange (file) {
      switch (file.status) {
        case 'ready':
          this.fileUpload = {
            fileName: file.name,
            status: 'selected'
          }
          if (this.useCustoms) {
            this.setOldFile(this.file)
            this.customOnChange(file)
          }
          break
        case 'fail':
          this.fileUpload = {
            fileName: file.name,
            status: 'failed'
          }
          if (this.useCustoms) {
            this.setOldFile(this.file)
            this.customOnChange(file)
          }
          break
        default:
          console.log(file.status)
      }
    },
    handleSuccess (res) {
      if (res === 'success') {
        this.uploadDisabled = false
        this.emitRefresh()
      } else if (!res || res === 'No such job') {
        this.fileUpload = {
          high_msg: 'Upload failed',
          status: 'failed'
        }
        this.uploadDisabled = false
      } else {
        try {
          this.uploadInterval = setInterval(async () => {
            const data = await this.getFileUploadJobStatus({
              jobId: res,
              studyId: this.id
            })
            if (data && data.status) {
              this.fileUpload = data
              if (['finished', 'failed'].includes(data.status)) {
                clearInterval(this.uploadInterval)
                this.uploadDisabled = false
                if (data.filename && data.filename !== this.file.name) {
                  this.file.name = data.filename
                }
              }
            }
          }, 2000)
        } catch (e) {
          clearInterval(this.uploadInterval)
          this.uploadDisabled = false
        }
      }
    },
    submitUpload (id) {
      this.uploadDisabled = true
      const refName = `upload-${id}`
      this.$refs[refName].submit()
      this.fileUpload = null
    },
    cancelUpload (id) {
      const refName = `upload-${id}`
      this.$refs[refName].clearFiles()
      this.fileUpload = null
    },
    emitRefresh () {
      this.$emit('refresh')
    },
    async customDownload (f) {
      await this.$emit('custom-download', f)
    },
    customCancelUpload () {
      this.$emit('custom-cancel-upload')
      this.fileUpload = null
    },
    async customUpload () {
      this.uploadDisabled = true
      await this.$emit('custom-upload')
      this.fileUpload = null
    },
    customOnChange (f) {
      this.$emit('custom-on-change', f)
    },
    setOldFile (f) {
      this.$emit('set-old-file', f)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';

.warning-icon {
  font-size: 15px;
  color: $red-600;
}
.list-group-item {
  padding-top: 5px;
  padding-bottom: 5px;
  transition: 0.15s linear;
}
.list-group-item:hover {
  background-color: rgba(200, 200, 200, 0.1);
}
.file-name {
  cursor: pointer;
}

.upload-button {
  display: none;
}

.upload-button.visible {
  display: unset;
}
.show-details-button {
  font-size: 12px;
  background-color: #409EFF;
  color: #fff;
  border-radius: .3rem;
  border: 1px solid #409EFF;
  padding: .5rem 1rem;
  &:hover {
    background-color: #66b1ff;
    border: 1px solid #66b1ff;
  }
}
</style>
